/* Pawfy: carruseles (pestañas, avance automático suave) y "Compra el look". */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Avance automático: una tarjeta cada X s, solo mientras el carrusel está a la vista.
     Al tocar, arrastrar o pasar el ratón se pausa, y vuelve a avanzar solo a los 6 s sin tocarlo
     (o al quitar el ratón). */
  function autoAvance(track) {
    if (reduce || track.dataset.pawfyAuto === 'on') return;
    track.dataset.pawfyAuto = 'on';
    var ms = Number(track.dataset.interval || 3500), timer = null, visible = false;
    var pausaHasta = 0, encima = false;
    function paso() {
      if (encima || Date.now() < pausaHasta || !visible || track.offsetParent === null) return;
      var card = track.firstElementChild; if (!card) return;
      var w = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 12);
      var fin = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
      track.scrollTo({ left: fin ? 0 : track.scrollLeft + w, behavior: 'smooth' });
    }
    function pausar() { pausaHasta = Date.now() + 6000; }
    ['pointerdown', 'touchstart', 'touchmove', 'wheel', 'focusin'].forEach(function (ev) {
      track.addEventListener(ev, pausar, { passive: true });
    });
    if (window.matchMedia('(hover: hover)').matches) {
      track.addEventListener('mouseenter', function () { encima = true; });
      track.addEventListener('mouseleave', function () { encima = false; pausaHasta = Date.now() + 1500; });
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }, { threshold: 0.4 }).observe(track);
    } else { visible = true; }
    timer = setInterval(paso, ms);
  }

  function flechas(root) {
    root.querySelectorAll('[data-pawfy-prev],[data-pawfy-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var track = root.querySelector('.pawfy-track:not([hidden])') || root.querySelector('.pawfy-track');
        var panel = btn.closest('[data-pawfy-carrusel]').querySelector('[role="tabpanel"]:not([hidden]) .pawfy-track');
        track = panel || track;
        track.dispatchEvent(new Event('pointerdown'));
        var dir = btn.hasAttribute('data-pawfy-next') ? 1 : -1;
        track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' });
      });
    });
  }

  function pestanas(root) {
    var tabs = root.querySelectorAll('[role="tab"]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.setAttribute('aria-selected', 'false'); });
        tab.setAttribute('aria-selected', 'true');
        root.querySelectorAll('[role="tabpanel"]').forEach(function (p) { p.hidden = p.id !== tab.getAttribute('aria-controls'); });
        var panel = root.querySelector('#' + tab.getAttribute('aria-controls'));
        // la pestaña estaba oculta: su contenido se muestra ya, sin esperar a la animación de scroll
        if (panel) panel.querySelectorAll('.pawfy-reveal').forEach(function (el) { el.classList.add('is-in'); });
        var track = panel && panel.querySelector('.pawfy-track');
        if (track) { track.scrollLeft = 0; track.dispatchEvent(new Event('pointerdown')); }
      });
    });
  }

  function look(root) {
    var spots = root.querySelectorAll('[data-pawfy-spot]');
    spots.forEach(function (s) {
      s.addEventListener('click', function () {
        spots.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        s.setAttribute('aria-pressed', 'true');
        root.querySelectorAll('[data-pawfy-look-card]').forEach(function (c) { c.toggleAttribute('data-active', c.dataset.pawfyLookCard === s.dataset.pawfySpot); });
      });
    });
  }

  /* Mazo de tarjetas: pasa solo; se desliza con el dedo; lista y puntos para elegir. */
  function deck(root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('.pawfy-deck__card'));
    var items = root.querySelectorAll('[data-go]');
    var dots = root.querySelectorAll('.pawfy-deck__dots [data-go], .pawfy-deck__dots i');
    var link = root.querySelector('[data-deck-link]');
    var n = cards.length, k = 0, timer = null, visible = false, pausaHasta = 0, swiped = false;
    if (!n) return;
    function lay() {
      cards.forEach(function (c, i) {
        var p = (i - k + n) % n;
        c.style.zIndex = String(10 - p);
        c.style.transform = 'translate(' + p * 14 + 'px,' + p * 10 + 'px) rotate(' + p * 3 + 'deg) scale(' + (1 - p * 0.04) + ')';
        c.style.opacity = p > 2 ? '0' : '1';
        c.tabIndex = p === 0 ? 0 : -1;
        c.setAttribute('aria-hidden', p === 0 ? 'false' : 'true');
      });
      items.forEach(function (b, i) { if (i === k) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
      dots.forEach(function (d, i) { d.classList.toggle('on', i === k); });
      if (link) link.href = cards[k].getAttribute('href');
    }
    function ir(nuevo, dir) {
      var saliente = cards[k];
      k = (nuevo + n) % n;
      if (!reduce && dir) {
        saliente.style.transform = 'translateX(' + (dir > 0 ? -115 : 115) + '%) rotate(' + (dir > 0 ? -10 : 10) + 'deg)';
        saliente.style.opacity = '0';
        setTimeout(lay, 320);
      } else { lay(); }
    }
    function pausar() { pausaHasta = Date.now() + 7000; }
    items.forEach(function (b) { b.addEventListener('click', function () { pausar(); ir(Number(b.dataset.go), Number(b.dataset.go) > k ? 1 : -1); }); });
    var prev = root.querySelector('[data-deck-prev]'), next = root.querySelector('[data-deck-next]');
    if (prev) prev.addEventListener('click', function () { pausar(); ir(k - 1, -1); });
    if (next) next.addEventListener('click', function () { pausar(); ir(k + 1, 1); });
    var stack = root.querySelector('.pawfy-deck__stack'), x0 = null;
    stack.addEventListener('pointerdown', function (e) { x0 = e.clientX; swiped = false; pausar(); });
    stack.addEventListener('pointerup', function (e) {
      if (x0 === null) return;
      var dx = e.clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) { swiped = true; ir(k + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1); }
    });
    stack.addEventListener('click', function (e) { if (swiped) { e.preventDefault(); swiped = false; } }, true);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }, { threshold: 0.4 }).observe(root);
    } else { visible = true; }
    lay();
    if (!reduce) timer = setInterval(function () { if (visible && Date.now() > pausaHasta) ir(k + 1, 1); }, 3200);
  }

  /* Opiniones: Judge.me carga sus últimas opiniones en su carrusel (que se oculta por CSS) y aquí
     se copian a una sección con el diseño de Pawfy. Así salen siempre las últimas, con este estilo. */
  function txt(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function crear(tag, cls, texto) { var e = document.createElement(tag); if (cls) e.className = cls; if (texto) e.textContent = texto; return e; }
  function opinionesJudgeme() {
    document.querySelectorAll('.jdgm-cards-carousel').forEach(function (w) {
      if (w.dataset.pawfyOp) return;
      var cards = w.querySelectorAll('.jdgm-carousel-item:not(.jdgm-clone-before):not(.jdgm-clone-after)');
      if (!cards.length) return;
      w.dataset.pawfyOp = '1';
      var notaM = txt(w.querySelector('.jdgm-header .jdgm-rating-text, .jdgm-average-rating .jdgm-rating-text')).match(/\d+[.,]\d+|\d+/);
      var nota = notaM ? notaM[0].replace('.', ',') : '';
      var total = txt(w.querySelector('.jdgm-reviews-count')).replace(/\D/g, '');
      var caja = crear('div', 'pawfy-op pawfy-op--auto');
      var pw = crear('div', 'page-width'); pw.setAttribute('data-pawfy-carrusel', '');
      var cab = crear('div', 'pawfy-sec__head pawfy-op__head');
      var izq = crear('div');
      izq.appendChild(crear('span', 'pawfy-eyebrow', ((window.pawfyT || {}).opEyebrow || 'Opiniones de clientes')));
      izq.appendChild(crear('h2', 'pawfy-sec__title', ((window.pawfyT || {}).opTitulo || 'Lo que dicen sus humanos')));
      /* Solo la nota y las estrellas: el número de opiniones no se enseña */
      if (nota) {
        var sc = crear('p', 'pawfy-op__score');
        sc.appendChild(crear('strong', '', nota));
        sc.appendChild(crear('span', 'pawfy-op__stars', '★★★★★'));
        izq.appendChild(sc);
      }
      cab.appendChild(izq);
      var flechas = crear('div', 'pawfy-arrows');
      flechas.innerHTML = '<button type="button" class="pawfy-arrow" data-pawfy-prev aria-label="Anteriores"><svg class="pawfy-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg></button><button type="button" class="pawfy-arrow" data-pawfy-next aria-label="Siguientes"><svg class="pawfy-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg></button>';
      cab.appendChild(flechas);
      pw.appendChild(cab);
      var track = crear('div', 'pawfy-track pawfy-op__track');
      track.setAttribute('data-auto', ''); track.setAttribute('data-interval', '3500');
      cards.forEach(function (c) {
        var fig = crear('figure', 'pawfy-op__card');
        var im = c.querySelector('img');
        var src = im ? (im.currentSrc || im.getAttribute('src') || im.getAttribute('data-src') || '') : '';
        if (src && !/^data:/.test(src)) {
          var ph = crear('div', 'pawfy-op__photo');
          var img = document.createElement('img');
          img.src = src.replace(/width=\d+/, 'width=600'); img.alt = ''; img.loading = 'lazy';
          ph.appendChild(img); fig.appendChild(ph);
        }
        var body = crear('div', 'pawfy-op__body');
        var n = c.querySelectorAll('.jdgm-star.jdgm--on').length || 5;
        var st = crear('span', 'pawfy-op__stars', '★★★★★'.slice(0, n) + '☆☆☆☆☆'.slice(0, 5 - n));
        st.setAttribute('aria-label', n + ' ' + ((window.pawfyT || {}).estrellas || 'de 5 estrellas'));
        body.appendChild(st);
        body.appendChild(crear('blockquote', 'pawfy-op__text', txt(c.querySelector('.jdgm-text'))));
        var quien = crear('figcaption', 'pawfy-op__who');
        quien.appendChild(crear('strong', '', txt(c.querySelector('.jdgm-reviewer-name'))));
        var ver = c.querySelector('.jdgm-reviewer-verified-icon');
        if (ver && getComputedStyle(ver).display !== 'none') {
          var v = crear('span', 'pawfy-op__verified');
          v.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="10" fill="currentColor"/><path d="m7.5 12.5 3 3 6-6.5" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          v.appendChild(document.createTextNode((window.pawfyT || {}).verificada || 'Compra verificada'));
          quien.appendChild(v);
        }
        var pr = c.querySelector('.jdgm-product-name');
        var prNombre = txt(pr);
        if (prNombre && prNombre.toUpperCase() !== 'PAWFY') {
          var href = pr.getAttribute('href');
          var el = href ? crear('a', 'pawfy-op__product', prNombre) : crear('span', 'pawfy-op__product', prNombre);
          if (href) el.href = href;
          quien.appendChild(el);
        }
        body.appendChild(quien);
        fig.appendChild(body);
        track.appendChild(fig);
      });
      pw.appendChild(track);
      caja.appendChild(pw);
      var sec = w.closest('.shopify-section') || w;
      sec.parentNode.insertBefore(caja, sec);
      sec.classList.add('pawfy-jdgm-fuente');
      init(caja);
    });
  }
  /* Descripción de producto: los párrafos de líneas cortas (p. ej. "Ajustables en cuello y pecho.<br>Neopreno suave…")
     se convierten en pastillas con un check; el párrafo que empieza por "Nota:" se destaca. */
  function descripcion() {
    var d = document.querySelector('.product__description');
    if (!d || d.dataset.pawfyDesc) return;
    d.dataset.pawfyDesc = '1';
    var check = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="10" fill="currentColor"/><path d="m7.5 12.5 3 3 6-6.5" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    d.querySelectorAll(':scope > p').forEach(function (p) {
      var texto = (p.textContent || '').trim();
      if (/^(nota|note)\s*:/i.test(texto)) { p.classList.add('pawfy-nota'); return; }
      if (!p.querySelector('br')) return;
      var lineas = p.innerHTML.split(/<br\s*\/?>/i).map(function (h) { var t = document.createElement('div'); t.innerHTML = h; return (t.textContent || '').trim(); }).filter(Boolean);
      if (lineas.length < 2 || lineas.some(function (l) { return l.length > 60; })) return;
      var ul = document.createElement('ul');
      ul.className = 'pawfy-feats';
      lineas.forEach(function (l) { var li = document.createElement('li'); li.innerHTML = check; li.appendChild(document.createTextNode(l.replace(/\.$/, ''))); ul.appendChild(li); });
      p.replaceWith(ul);
    });
  }
  if (document.readyState !== 'loading') descripcion(); else document.addEventListener('DOMContentLoaded', descripcion);

  var vueltasOp = 0;
  var relojOp = setInterval(function () {
    opinionesJudgeme();
    if (++vueltasOp > 30) {
      clearInterval(relojOp);
      /* si Judge.me no ha cargado, se vuelve a mostrar su carrusel tal cual */
      document.querySelectorAll('.jdgm-cards-carousel:not([data-pawfy-op])').forEach(function (w) { w.classList.add('pawfy-jdgm-fallo'); });
    }
  }, 700);

  function init(scope) {
    (scope || document).querySelectorAll('[data-pawfy-deck]').forEach(function (root) {
      if (root.dataset.pawfyInit) return; root.dataset.pawfyInit = '1'; deck(root);
    });
    (scope || document).querySelectorAll('[data-pawfy-carrusel]').forEach(function (root) {
      if (root.dataset.pawfyInit) return; root.dataset.pawfyInit = '1';
      pestanas(root); flechas(root);
      root.querySelectorAll('.pawfy-track[data-auto]').forEach(autoAvance);
    });
    (scope || document).querySelectorAll('[data-pawfy-look]').forEach(function (root) {
      if (root.dataset.pawfyInit) return; root.dataset.pawfyInit = '1'; look(root);
    });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
